import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tr,
} from "@chakra-ui/react";
import accounting from "accounting";

const ScenarioMonth = ({ month, index }: { month: any; index: number }) => {
  return (
    <Box mr="20px" minW="400px">
      <Box bg="gray" textAlign="center">
        <Text color="white">Month {index}</Text>
      </Box>
      <TableContainer>
        <Table size="sm" variant="loan-fields">
          <Tbody>
            <Tr>
              <Td px="12px">Days</Td>
              <Td textAlign="right">{month["Days"]}</Td>
            </Tr>
            <Tr>
              <Td px="12px">EO Month</Td>
              <Td textAlign="right">{month["EO Month"]}</Td>
            </Tr>
            <Tr>
              <Td px="12px">Interest Only?</Td>
              <Td textAlign="right">{month["Interest Only"]}</Td>
            </Tr>
            <Tr>
              <Td px="12px">Ann. Rate</Td>
              <Td textAlign="right">
                {(month["Ann. Rate"] * 100).toFixed(2)}%
              </Td>
            </Tr>
            <Tr></Tr>
            <Tr>
              <Td px="12px">Beginning Balance</Td>
              <Td textAlign="right">
                {accounting.formatMoney(month["Beginning Balance"])}
              </Td>
            </Tr>
            <Tr>
              <Td px="12px">Payment</Td>
              <Td textAlign="right">
                {accounting.formatMoney(month["Payment"])}
              </Td>
            </Tr>
            <Tr>
              <Td px="12px">Principal</Td>
              <Td textAlign="right">
                {accounting.formatMoney(month["Principal"])}
              </Td>
            </Tr>
            <Tr>
              <Td px="12px">Interest</Td>
              <Td textAlign="right">
                {accounting.formatMoney(month["Interest"])}
              </Td>
            </Tr>
            <Tr>
              <Td px="12px">Ending Balance</Td>
              <Td textAlign="right">
                {accounting.formatMoney(month["Ending Balance"])}
              </Td>
            </Tr>
            <Tr>
              <Td px="12px">Lender CF</Td>
              <Td textAlign="right">
                {accounting.formatMoney(month["Lender CF"])}
              </Td>
            </Tr>
            <Tr>
              <Td colSpan={2}></Td>
            </Tr>
            <Tr>
              <Td px="12px">Weight</Td>
              <Td textAlign="right">
                {accounting.formatMoney(month["Weight"])}
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ScenarioMonth;
